import { Card } from "@/components/ui/Card";
import EventTable from "./component/table";
import useDocumentTitle from "@/hooks/UseDocumentTitle";

const Events = () => {
  useDocumentTitle("Events");

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <EventTable />
      </Card>
    </div>
  );
};

export default Events;
